import React from 'react';
import Text from 'components/Text';
import { Row, Column } from 'components/Layout/Grid';
import { CurrencyInput } from 'components/CurrencyInput';
import { DiscountValueProps } from './interface';

export const DiscountValue: React.FC<DiscountValueProps> = (props) => {
  const {
    discountValue,
    setDiscountValue,
    isEditing
  } = props;

  return (
    <Row className="mt-5 flex-md-column">
      <Column className="mt-md-2 mr-md-2">
        <Text className="mb-2 flex-md-100 color-blue-gray" size={12}>
          Valor do Desconto
        </Text>
        <CurrencyInput
          id="discount-value"
          name="Valor do Desconto"
          placeholder="Valor do Desconto"
          value={discountValue}
          setValue={setDiscountValue}
          required={true}
          isEditing={isEditing}
        />
      </Column>
    </Row>
  );
};